import { toObjectMap } from "@@/utilities/dictionary";

const providerStatusTypes = [
    "ACTIVE",
    "OPEN",
    "CLOSED",
    "PAUSED",
    "HIDDEN",
    "DOES_NOT_EXIST",
] as const;
type ProviderStatusType = typeof providerStatusTypes[number];
const providerStatusTypeMap = toObjectMap<ProviderStatusType>([
    ...providerStatusTypes,
]);
export { providerStatusTypes, providerStatusTypeMap };
export type { ProviderStatusType };
